/**
 * Asynchronously loads the component for GuaranteeReportDetailPage
 */

import { lazyLoad } from 'utils/loadable';

export const GuaranteeReportDetailPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeReportDetailPage,
);
